var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.334705 8.26569C0.0222859 7.95327 0.0222859 7.44673 0.334705 7.13431L2.96902 4.5L0.334705 1.86568C0.0222859 1.55327 0.0222859 1.04673 0.334705 0.734314C0.647125 0.421895 1.15366 0.421895 1.46608 0.734314L4.66608 3.93431C4.9785 4.24673 4.9785 4.75327 4.66608 5.06569L1.46608 8.26569C1.15366 8.5781 0.647125 8.5781 0.334705 8.26569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.35eff4d9e8f2a668cdc8605645fd9ed7.svg";
export { ForwardRef as ReactComponent };